import { apiGet } from "../baseApi";
import { setDomainData } from "service/mapper";

export const getList = async ({ params, config = {} }) => {
  try {
    const response = await apiGet("_domain", params, null, config);
    return {
      ...response,
      rowData: (Array.isArray(response.data.domains)
        ? response.data.domains
        : []
      ).map((el) => setDomainData(el)),
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
